/**
 * MarketingSEO — sets a unique <title> and meta description per public
 * marketing route (fixes every page inheriting the homepage's meta).
 * Rendered once inside the public marketing site tree.
 */
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE = 'Cobra Thai';
const DEFAULT = {
  title: `${SITE} | Premier MMA & Martial Arts Academy in Kharadi, Pune`,
  description:
    "Cobra Thai is Pune's premier MMA & martial arts academy in Kharadi. World-class coaching in Muay Thai, Brazilian Jiu-Jitsu, Boxing, Kickboxing, MMA & Wrestling. All levels welcome.",
};

const ROUTES = {
  '/': DEFAULT,
  '/about': {
    title: `About ${SITE} | Martial Arts Academy in Pune`,
    description:
      "Meet Cobra Thai — Pune's leading martial arts academy in Kharadi. Our champion coaches, world-class facility and community-first approach to MMA, Muay Thai & BJJ training.",
  },
  '/membership': {
    title: `Membership & Pricing | ${SITE} Kharadi, Pune`,
    description:
      'Flexible Cobra Thai memberships for MMA, Muay Thai, Boxing, Kickboxing and Brazilian Jiu-Jitsu in Kharadi, Pune. Book a free trial and train with champions today.',
  },
  '/schedule': {
    title: `Class Schedule & Timetable | ${SITE} Pune`,
    description:
      'View the full Cobra Thai class timetable in Kharadi, Pune — Muay Thai, BJJ, Boxing, Kickboxing, MMA and Wrestling classes for all skill levels, morning to evening.',
  },
  '/elite-residency': {
    title: `Elite Fighter Residency | ${SITE} Pune`,
    description:
      "Cobra Thai's Elite Residency: an immersive full-time training programme for serious fighters in Pune. World-class coaching, strength & conditioning, and fight preparation.",
  },
  '/privacy': {
    title: `Privacy Policy | ${SITE}`,
    description: 'How Cobra Thai collects, uses and protects your personal information.',
  },
  '/terms': {
    title: `Terms & Conditions | ${SITE}`,
    description: 'Cobra Thai membership terms & conditions, no-refund policy, assumption of risk, and code of conduct for our Kharadi, Pune academy.',
  },
  '/blog': {
    title: `Blog | ${SITE} — MMA & Martial Arts Tips`,
    description:
      'Training tips, fighter stories and martial arts insights from the Cobra Thai team in Kharadi, Pune. Muay Thai, BJJ, boxing and MMA guidance for every level.',
  },
};

export default function MarketingSEO() {
  const { pathname } = useLocation();
  // Exact match first; blog posts / dynamic pages fall back to the section default.
  const meta =
    ROUTES[pathname] ||
    (pathname.startsWith('/blog') ? ROUTES['/blog'] : DEFAULT);
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
